import { useEffect, useState } from "react";
import { loadMe, type Me } from "../data/me.js";

export function useMe(): { me: Me | null; loading: boolean } {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    loadMe()
      .then((m) => {
        if (alive) setMe(m);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);
  return { me, loading };
}
